import { useState, useCallback } from 'react';

export interface PaginationState {
  page: number;
  pageSize: number;
  total: number;
  pageCount: number;
}

export interface UsePaginationReturn {
  pagination: PaginationState;
  setPagination: (pagination: Partial<PaginationState>) => void;
  handlePageChange: (newPage: number) => void;
  handlePageSizeChange: (newPageSize: number) => void;
  resetPagination: () => void;
}

export const usePagination = (
  initialPageSize: number = 10
): UsePaginationReturn => {
  const [pagination, setPaginationState] = useState<PaginationState>({
    page: 0, // MUI TablePagination uses 0-based indexing
    pageSize: initialPageSize,
    total: 0,
    pageCount: 0,
  });

  const setPagination = useCallback((newPagination: Partial<PaginationState>) => {
    setPaginationState((prev) => ({ ...prev, ...newPagination }));
  }, []);

  const handlePageChange = useCallback((newPage: number) => {
    setPaginationState((prev) => ({ ...prev, page: newPage }));
  }, []);

  const handlePageSizeChange = useCallback((newPageSize: number) => {
    setPaginationState((prev) => ({
      ...prev,
      pageSize: newPageSize,
      page: 0, // Reset to first page when page size changes
    }));
  }, []);

  const resetPagination = useCallback(() => {
    setPaginationState({
      page: 0,
      pageSize: initialPageSize,
      total: 0,
      pageCount: 0,
    });
  }, [initialPageSize]);

  return {
    pagination,
    setPagination,
    handlePageChange,
    handlePageSizeChange,
    resetPagination,
  };
};














